import "core-js/modules/es6.regexp.constructor.js";
var rules = {
  /**
   * Required field
   *
   * @param val
   * @returns boolean|string
   */
  required: function required(val) {
    var rule = val !== null && val !== '' && val.length > 0;
    return rule || 'This field is required';
  },
  /**
   * Password min length 8 chars.
   *
   * @param val
   * @returns {(function(*): boolean)|string}
   */
  password: function password(val) {
    var rule = val.length === 0 || val.length >= 8;
    return rule || 'Password has to be at least 8 characters long';
  },
  /**
   * Confirm the password
   *
   * @param compare
   * @returns {(function(*): boolean)|string}
   */
  confirmPassword: function confirmPassword(compare) {
    return function (val) {
      var rule = val === compare;
      return rule || 'Confirmation password does not match';
    };
  },
  /**
   * Validate Email
   *
   * @param val
   * @returns {boolean | string}
   */
  email: function email(val) {
    var re = RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}' + '\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
    var rule = re.test(String(val).toLowerCase());
    return rule || 'Please type valid email address';
  },
  /**
   * Max character length
   *
   * @param maxVal
   * @returns {function(*): (boolean|string)}
   */
  maxLength: function maxLength() {
    var maxVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 255;
    return function (val) {
      var rule = true;
      if (val) {
        rule = val.length <= maxVal;
      }
      return rule || "Maximum ".concat(maxVal, " characters are allowed");
    };
  },
  /**
   * Supported characters a-z, -, _, ' '
   *
   * @param val
   * @returns {boolean | string}
   */
  supportedCharacters: function supportedCharacters(val) {
    var re = RegExp('^[a-z0-9-_\\s]+$');
    var rule = re.test(val);
    return rule || 'Supported characters are lower case letters, numbers, spaces, dash(-) and underscore(_)';
  }
};
export default rules;